<template>
  <div class="space-y-2">
    <div v-for="index in 5" :key="index" class="rounded-m animate-pulse bg-neutral-100 px-3 py-5" />
  </div>
</template>
